import { PayloadAction, createSlice } from "@reduxjs/toolkit";
import { IReviewData } from "../../utility/types/reviewType";
import {
  createReview,
  getAllReviews,
  getUserReview,
} from "../actions/reviewAction";

export interface ReviewState {
  reviewData: IReviewData[] | null;
  isLoading: boolean;
  error: string;
}

const initialState: ReviewState = {
  reviewData: [],
  isLoading: false,
  error: "",
};

const reviewSlice = createSlice({
  name: "review",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(
      createReview.pending,
      (state, action: PayloadAction<any>) => {
        state.isLoading = true;
      }
    );

    builder.addCase(
      createReview.fulfilled,
      (state, action: PayloadAction<any>) => {
        state.isLoading = false;
        state.reviewData = action.payload;
      }
    );

    builder.addCase(
      createReview.rejected,
      (state, action: PayloadAction<any>) => {
        state.isLoading = false;
        state.error = action.payload;
      }
    );

    builder.addCase(
      getUserReview.pending,
      (state, action: PayloadAction<any>) => {
        state.isLoading = true;
      }
    );

    builder.addCase(
      getUserReview.fulfilled,
      (state, action: PayloadAction<any>) => {
        state.isLoading = false;
        state.reviewData = action.payload;
      }
    );

    builder.addCase(
      getUserReview.rejected,
      (state, action: PayloadAction<any>) => {
        state.isLoading = false;
        state.error = action.payload;
      }
    );

    builder.addCase(
      getAllReviews.pending,
      (state, action: PayloadAction<any>) => {
        state.isLoading = true;
      }
    );

    builder.addCase(
      getAllReviews.fulfilled,
      (state, action: PayloadAction<any>) => {
        state.isLoading = false;
        state.reviewData = action.payload || [];
      }
    );

    builder.addCase(
      getAllReviews.rejected,
      (state, action: PayloadAction<any>) => {
        state.isLoading = false;
        state.error = action.payload;
      }
    );
  },
});

export default reviewSlice.reducer;
